import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_COMPARE_API =
  'DASHBOARD/FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_COMPARE_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_IDENTIFICATION_DETAIL_COMPARE_API,
  ({ id }) => ({
    endpoint: `/api/admin/users/identifications/${id}/draft-compare`,
    method: 'GET',
  })
);

export default apiCall;
